var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.xmIconList !== null)?_c('div',{staticClass:"album-tags-pc"},_vm._l((_vm.xmIconList),function(icon,index){return _c('div',{key:index,staticClass:"tags-item-wrapper",on:{"click":function($event){_vm.clickTag(icon)}}},[_c('img',{attrs:{"src":icon.src}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(icon.text))])])})):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91f25e90","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xc_time/album-tags/album-tags-pc.vue
// module id = 1602
// module chunks = 0